export default __webpack_public_path__ + "static/media/Parent_Parties_Horz_Navy.54d47dd1.png";